// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBatteryVerticalCharging20Solid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h-4zm5 3H9a1 1 0 0 0-1 1v11.8h4.842c-.502 1.003.222 2.225 1.383 2.225h.8l-.505 2.526c-.031.157-.04.307-.03.449H9a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v5.42a1.485 1.485 0 0 0-1.53.695l-.47.734V6a1 1 0 0 0-1-1zm3 7.766c.049.06.073.143.054.237l-.054.272-.75 3.75h2.325c.23 0 .37.255.246.449L17.98 20.35l-1.414 2.208-.289.452c-.174.271-.595.102-.531-.215l.804-4.021h-2.325a.298.298 0 0 1-.158-.046.292.292 0 0 1-.088-.403l3.543-5.537a.285.285 0 0 1 .37-.107.3.3 0 0 1 .108.084z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBatteryVerticalCharging20Solid;
